__turbopack_context__.v({
  "avatarImage": "_9eilXq_avatarImage",
  "avatarLink": "_9eilXq_avatarLink",
  "avatarMenuTrigger": "_9eilXq_avatarMenuTrigger",
  "avatarText": "_9eilXq_avatarText",
});
